
import React from 'react';
import classes from './SliderArrows.module.scss';


type CustomArrowProps = {
  onClick?: () => void;
  hide?: boolean;
};

export const CustomNextArrow: React.FC<CustomArrowProps> = ({ onClick, hide }) => {
  if (hide) return null;

  return (
    <div className={classes.nextArrow} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="108" height="106" viewBox="0 0 108 106" fill="none">
        <ellipse cx="54.1234" cy="53" rx="53.2484" ry="53" fill="#202D52"/>
        <path d="M44.0767 30L69.1938 52.5L44.0767 75" stroke="white" stroke-width="5" stroke-linecap="round"/>
      </svg>
    </div>
  );
};

export const CustomPrevArrow: React.FC<CustomArrowProps> = ({ onClick, hide }) => {
  if (hide) return null;

  return (
    <div className={classes.prevArrow} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="106" height="106" viewBox="0 0 106 106" fill="none">
  <circle cx="53" cy="53" r="53" transform="rotate(-180 53 53)" fill="#202D52"/>
  <path d="M63 76L38 53.5L63 31" stroke="white" stroke-width="5" stroke-linecap="round"/>
</svg>
    </div>
  );
};
